module.exports = __webpack_public_path__ + "img/rose-2.2e3ea7ba.png";